module.exports = __webpack_public_path__ + "img/goias.7827418a.jpg";